import { createApp } from 'vue'
import App from './App.vue'
import createDynamicRouter from './router'
import VueGtag from 'vue-gtag-next';
import store from './store'; // Vuex ストアのインポート
import './styles/global.css';

createDynamicRouter().then(router => {
    // console.log('main.js Vue app is initializing...'); 
     
    const app = createApp(App);
 
    // Google Analyticsの設定
    app.use(VueGtag, {
        property: {
            id: process.env.VUE_APP_GA_MEASUREMENT_ID
        }
    }, router);

    // Vue Routerのナビゲーションごとにページビューを送信
    router.afterEach((to) => {
      app.config.globalProperties.$gtag.pageview({
        page_path: to.fullPath,
      });
    });

    // Vue RouterのbaseをVuexストアに設定
    const base = router.options.history.base || '';
    // console.log('main.js createDynamicRouter() base with:', base); // 追加のログ

    app.use(router);
    app.use(store);

    // store.dispatch('base/initializeBase', base);
    store.dispatch('base/initializeBase', base)
    .then(() => {
        // console.log('main.js initializeBase action dispatched successfully'); // アクションが成功した場合
        // console.log('main.js store state after dispatch:', store.state.base); // storeのstateを確認
        app.mount('#app');
    })
    .catch(error => {
        console.error('main.js failed to dispatch initializeBase action:', error); // アクションが失敗した場合
    });
}).catch(error => {
    console.error('Failed to initialize router: ', error);
})